import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "messageContainer", "editor"];
  static values = {
    originalStatus: String,
    templates: Object,
  };

  connect() {
    if (this.selectTarget.value === this.originalStatusValue) {
      this.toggleMessage();
    }
  }

  statusChanged() {
    this.toggleMessage();
  }

  toggleMessage() {
    const status = this.selectTarget.value;
    const changed = status !== this.originalStatusValue;
    const hasTemplate = Object.prototype.hasOwnProperty.call(this.templatesValue, status);

    if (changed && hasTemplate) {
      this.messageContainerTarget.classList.remove("d-none");
      this.setEditorHtml(this.templatesValue[status] || "");
      this.editorTarget.focus();

      // Wait for layout and Trix render to complete, then scroll to bring
      // editor into view, taking into account the form footer if it exists
      requestAnimationFrame(() => {
        const footer = this.element.closest("form")?.querySelector(".form-footer");
        const footerHeight = footer?.offsetHeight ?? 0;
        this.messageContainerTarget.style.scrollMarginBottom = `${footerHeight + 16}px`;
        this.messageContainerTarget.scrollIntoView({ behavior: "smooth", block: "end" });
      });
    } else {
      this.messageContainerTarget.classList.add("d-none");
      this.setEditorHtml("");
    }
  }

  // Trix editors load asynchronously; if the controller connects before the
  // editor is initialized, defer loadHTML until trix-initialize fires
  setEditorHtml(html) {
    if (this.editorTarget.editor) {
      this.editorTarget.editor.loadHTML(html);
    } else {
      this.editorTarget.addEventListener("trix-initialize", () => this.editorTarget.editor.loadHTML(html), {
        once: true,
      });
    }
  }
}
